/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { WellKnownMimeType } from 'rsocket-composite-metadata';
import { Cancellable, OnExtensionSubscriber, OnNextSubscriber, OnTerminalSubscriber, Requestable } from 'rsocket-core';

// This enum is used to determine the base websocket URL for the RSocket connection
export enum StreamRequestType {
  MotorsportsStreamApi,
  DataScienceStreamApi,
}

export interface RSocketBaseServiceInterface {
  reset: (hard?: boolean) => void;
}

export const MESSAGE_RSOCKET_ROUTING = WellKnownMimeType.MESSAGE_RSOCKET_ROUTING;
export const MESSAGE_RSOCKET_COMPOSITE_METADATA = WellKnownMimeType.MESSAGE_RSOCKET_COMPOSITE_METADATA;
export const MESSAGE_RSOCKET_AUTHENTICATION = WellKnownMimeType.MESSAGE_RSOCKET_AUTHENTICATION;
export const APPLICATION_CBOR = WellKnownMimeType.APPLICATION_CBOR;

export type RSocketStreamClientInterface = Requestable & Cancellable & OnExtensionSubscriber;
export type RSocketChannelClientInterface = OnTerminalSubscriber &
  OnNextSubscriber &
  OnExtensionSubscriber &
  Requestable &
  Cancellable;
